import React from 'react';
import { Container, Popup } from 'semantic-ui-react';
import AdvertiserDisclosure from './Advertiser';

const AdvertiserDisclosurePopUp = ({position}) => {

    return (
        <Popup
            trigger={<a className='link__disclosure'>Advertiser Disclosure</a>}
            position={position ? position : 'bottom center'}
            wide="very"
        >
            <Container fluid className="disclosures">
                <AdvertiserDisclosure />
            </Container>

        </Popup>
    );
};

export default AdvertiserDisclosurePopUp;